import OmTextField from '../ui/OmTextField';
import OmSelect from '../ui/OmSelect';
import OmSelectOption from '../ui/OmSelectOption';

const ClaimsFilters = ({
  searchTerm,
  setSearchTerm,
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
  statusFilter,
  setStatusFilter
}) => {
  const getFilterSummary = () => {
    const activeFilters = [];
    
    return activeFilters;
  };

  const activeFilters = getFilterSummary();

  return (
    <div className="card mb-8" style={{ borderRadius: '0.5rem' }}>
      <div className="card-body">
        {/* Active Filters Summary */}
        {activeFilters.length > 0 && (
          <div className="mb-4 flex flex-wrap gap-2">
            <span className="text-sm font-medium text-gray-600">Active filters:</span>
            {activeFilters.map((filter, index) => (
              <span
                key={index}
                className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
              >
                {filter}
              </span>
            ))}
          </div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Search */}
          <div className="space-y-2">
            <div style={{
              '--omk-text-field-container-color': '#ffffff',
              '--omk-text-field-label-text-color': '#006250',
              '--omk-text-field-input-text-color': '#334155',
              '--omk-text-field-outline-color': 'rgba(86, 163, 83, 0.3)',
              '--omk-text-field-focus-outline-color': '#56a353',
              '--omk-text-field-caret-color': '#56a353'
            }}>
              <OmTextField
                label="Search Claims"
                placeholder="Search by ID, policy number, or name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                type="text"
              />
            </div>
          </div>

          {/* Sort By */}
          <div className="space-y-2">
            <div style={{
              '--omk-select-text-field-container-color': '#ffffff',
              '--omk-select-text-field-label-text-color': '#006250',
              '--omk-select-text-field-input-text-color': '#334155',
              '--omk-select-text-field-outline-color': 'rgba(86, 163, 83, 0.3)',
              '--omk-select-text-field-focus-outline-color': '#56a353'
            }}>
              <OmSelect
                label="Sort By"
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <OmSelectOption value="createdAt">Date Created</OmSelectOption>
                <OmSelectOption value="updatedAt">Last Updated</OmSelectOption>
                <OmSelectOption value="benefitAmount">Claim Amount</OmSelectOption>
                <OmSelectOption value="status">Status</OmSelectOption>
              </OmSelect>
            </div>
          </div>

          {/* Sort Order */}
          <div className="space-y-2">
            <div style={{
              '--omk-select-text-field-container-color': '#ffffff',
              '--omk-select-text-field-label-text-color': '#006250',
              '--omk-select-text-field-input-text-color': '#334155',
              '--omk-select-text-field-outline-color': 'rgba(86, 163, 83, 0.3)',
              '--omk-select-text-field-focus-outline-color': '#56a353'
            }}>
              <OmSelect
                label="Order"
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
              >
                <OmSelectOption value="desc">Newest First</OmSelectOption>
                <OmSelectOption value="asc">Oldest First</OmSelectOption>
              </OmSelect>
            </div>
          </div>

          {/* Status Filter */}
          <div className="space-y-2">
            <div style={{
              '--omk-select-text-field-container-color': '#ffffff',
              '--omk-select-text-field-label-text-color': '#006250',
              '--omk-select-text-field-input-text-color': '#334155',
              '--omk-select-text-field-outline-color': 'rgba(86, 163, 83, 0.3)',
              '--omk-select-text-field-focus-outline-color': '#56a353'
            }}>
              <OmSelect
                label="Status"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <OmSelectOption value="all">All</OmSelectOption>
                <OmSelectOption value="SUBMITTED">Submitted</OmSelectOption>
                <OmSelectOption value="UNDER_REVIEW">Under Review</OmSelectOption>
                <OmSelectOption value="MISSING_DOCUMENTS">Missing Documents</OmSelectOption>
                <OmSelectOption value="RECOMMENDED_FOR_APPROVAL">Recommended</OmSelectOption>
                <OmSelectOption value="APPROVED">Approved</OmSelectOption>
                <OmSelectOption value="PAYMENT_PENDING">Payment Pending</OmSelectOption>
                <OmSelectOption value="PAID">Paid</OmSelectOption>
                <OmSelectOption value="REJECTED">Rejected</OmSelectOption>
              </OmSelect>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClaimsFilters;
